import React, { useState, useMemo } from 'react';
import { Brain, Trophy, RotateCcw, Check, X as XIcon } from 'lucide-react';

const QUESTIONS = [
  { q: 'How long is a full marathon?', a: ['42.2 km', '26 km', '50 km', '10 km'], correct: 0 },
  { q: 'What does "PB" stand for in running?', a: ['Pace Band', 'Personal Best', 'Power Bar', 'Push Back'], correct: 1 },
  { q: 'Which is a common warm-up before a run?', a: ['Heavy squats', 'Dynamic stretches', 'A big meal', 'A long nap'], correct: 1 },
  { q: 'A "negative split" means you run the...', a: ['First half faster', 'Second half faster', 'Whole race slow', 'Race backwards'], correct: 1 },
  { q: 'Roughly how many km is a 5K?', a: ['3 km', '5 km', '8 km', '10 km'], correct: 1 },
  { q: 'What mostly fuels endurance running?', a: ['Protein', 'Fat & carbs', 'Vitamin C', 'Caffeine only'], correct: 1 },
  { q: 'Cadence in running refers to your...', a: ['Steps per minute', 'Heart rate', 'Shoe size', 'Water intake'], correct: 0 },
  { q: 'Best way to avoid injury when adding mileage?', a: ['Double it weekly', 'Increase gradually', 'Never rest', 'Skip warm-ups'], correct: 1 },
  { q: 'What is "tempo" running?', a: ['A gentle jog', 'Comfortably hard pace', 'Full sprint', 'Walking'], correct: 1 },
  { q: 'Hydration is most important...', a: ['Only after', 'Before, during & after', 'Never', 'Only in winter'], correct: 1 },
];

function shuffle(arr) { return [...arr].sort(() => Math.random() - 0.5); }

export default function Trivia() {
  const [deck, setDeck] = useState(() => shuffle(QUESTIONS).slice(0, 6));
  const [idx, setIdx] = useState(0);
  const [picked, setPicked] = useState(null);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);
  const [best, setBest] = useState(() => { try { return Number(localStorage.getItem('spc_trivia_best')) || 0; } catch { return 0; } });

  const current = deck[idx];
  const total = deck.length;

  const pick = (i) => {
    if (picked !== null) return;
    setPicked(i);
    const right = i === current.correct;
    const newScore = right ? score + 1 : score;
    if (right) setScore(newScore);
    setTimeout(() => {
      if (idx + 1 >= total) {
        setDone(true);
        if (newScore > best) { setBest(newScore); try { localStorage.setItem('spc_trivia_best', String(newScore)); } catch {} }
      } else {
        setIdx(idx + 1); setPicked(null);
      }
    }, 850);
  };

  const restart = () => { setDeck(shuffle(QUESTIONS).slice(0, 6)); setIdx(0); setPicked(null); setScore(0); setDone(false); };

  return (
    <div className="solo-game" data-testid="solo-trivia">
      <div className="solo-head">
        <div className="solo-title"><Brain size={18} /><span>SPC Trivia</span></div>
        <div className="solo-score">
          {best > 0 && <span className="pill yellow"><Trophy size={12} /> Best {best}/6</span>}
          {!done && <span className="pill">Q{idx + 1}/{total}</span>}
        </div>
      </div>

      {done ? (
        <div className="trivia-done" data-testid="trivia-done">
          <div className="trivia-score-big">{score}<span>/{total}</span></div>
          <p>{score === total ? 'Perfect run! 🏆' : score >= total / 2 ? 'Nice work — keep training!' : 'Warm up those brain cells!'}</p>
          <button className="btn" onClick={restart} data-testid="trivia-restart"><RotateCcw size={14} /> Play again</button>
        </div>
      ) : (
        <>
          <div className="trivia-q" data-testid="trivia-question">{current.q}</div>
          <div className="trivia-options">
            {current.a.map((opt, i) => {
              let cls = '';
              if (picked !== null) {
                if (i === current.correct) cls = 'correct';
                else if (i === picked) cls = 'wrong';
              }
              return (
                <button key={i} className={`trivia-opt ${cls}`} disabled={picked !== null} onClick={() => pick(i)} data-testid={`trivia-opt-${i}`}>
                  <span>{opt}</span>
                  {cls === 'correct' && <Check size={16} />}
                  {cls === 'wrong' && <XIcon size={16} />}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
